"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _material = require("@mui/material");

var _qs = _interopRequireDefault(require("qs"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class CustomLogin extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onChange", e => {
      this.setState({
        [e.target.name]: e.target.value
      });
    });

    _defineProperty(this, "onSubmit", e => {
      e.preventDefault();
      const {
        email,
        password
      } = this.state; // Validate entry

      if (email == null || email === '' || password == null || password === '') {
        this.props.setError('Please fill in both email and password.');
        return;
      }

      this.props.onLogin(email, password);
    });

    this.state = {
      email: '',
      password: '',
      redirect: false
    };
  }

  componentDidMount() {
    var _qs$parse, _window, _window$location;

    let email = (_qs$parse = _qs.default.parse((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search, {
      ignoreQueryPrefix: true
    })) === null || _qs$parse === void 0 ? void 0 : _qs$parse.email;

    if (email != null) {
      this.setState({
        email: email
      });
    }
  }

  render() {
    if (this.props.redirect) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: this.props.redirectLink
    });
    return /*#__PURE__*/_react.default.createElement(_material.Container, null, /*#__PURE__*/_react.default.createElement("form", {
      autoComplete: "off",
      onSubmit: this.onSubmit,
      style: {
        marginBottom: '5em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '2em',
        marginBottom: '1em'
      }
    }, this.props.logo != null && /*#__PURE__*/_react.default.createElement("img", {
      width: 250,
      src: this.props.logo,
      alt: 'Logo',
      title: 'Logo',
      style: {
        objectFit: 'contain'
      }
    })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "h1",
      style: {
        textAlign: 'center',
        marginBottom: '1em'
      }
    }, "Login"), /*#__PURE__*/_react.default.createElement(_material.TextField, {
      required: true,
      disabled: this.props.isLoading,
      error: this.state.formError && this.state.email === '',
      name: "email",
      label: "Email",
      type: "email",
      style: {
        width: '100%',
        marginBottom: '10px'
      },
      value: this.state.email,
      onChange: this.onChange,
      variant: "filled"
    }), /*#__PURE__*/_react.default.createElement(_material.TextField, {
      required: true,
      disabled: this.props.isLoading,
      error: this.state.formError && this.state.password === '',
      name: "password",
      label: "Password",
      style: {
        width: '100%',
        marginBottom: '10px'
      },
      value: this.state.password,
      onChange: this.onChange,
      variant: "filled",
      type: "password"
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '40px'
      }
    }, /*#__PURE__*/_react.default.createElement(_.Button, {
      type: "submit",
      isLoading: this.props.isLoading,
      style: {
        width: '50%'
      }
    }, "Login"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "button",
      style: {
        marginTop: '10px'
      }
    }, "Need to make an account?", ' ', /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: this.props.createAccountLink,
      style: {
        color: this.props.color
      }
    }, "Create one now"), "."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "button",
      style: {
        marginTop: '10px'
      }
    }, "Forgot your password?", ' ', /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: this.props.resetPasswordLink,
      style: {
        color: this.props.color
      }
    }, "Reset Now"), "."))));
  }

}

CustomLogin.propTypes = {
  setError: _propTypes.default.func.isRequired,
  onLogin: _propTypes.default.func.isRequired,
  redirectLink: _propTypes.default.string.isRequired,
  createAccountLink: _propTypes.default.string.isRequired,
  resetPasswordLink: _propTypes.default.string.isRequired,
  logo: _propTypes.default.any,
  color: _propTypes.default.string.isRequired,
  redirect: _propTypes.default.bool.isRequired,
  isLoading: _propTypes.default.bool.isRequired
};
var _default = CustomLogin;
exports.default = _default;